import { BattingStatisticsModel } from "./BattingStatistics";
import { FieldingStatisticsModel } from "./FieldingStatistics";
import { PitchingStatisticsModel } from "./PitchingStatistics";
import { PlayerStats } from "./PlayerStats";
import { TeamScoreModel } from "./TeamScore";

export class PlayerModel {
    public mlbId = '';
    public name: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public get fullName(): string {
        return (this.firstName + ' ' + this.lastName).replace(/ +(?= )/g,'');
    }
    public get isPitcher(): boolean {
        return this.position.toLowerCase() === 'pitcher' || this.positionAbbr.toLowerCase() === 'p';
    }
    public get nameLineup():string{
        const fChar:string = this.name.length > 0 ? this.name.charAt(0) : '';
        const parts:string[] = this.name.split(' ');
        let pPars:string = '';
        let i:number = 0;
        for(let p of parts){
            if(i > 1){
                pPars += ' ' + p;
            }
            i++;
        }
        pPars = pPars.replace(' - ', ', ');
        return fChar + '. ' + (parts.length > 1 ? parts[1] : '') + pPars;
    };
    public get namePitcher():string{
        const fChar:string = this.name.length > 0 ? this.name.charAt(0) : '';
        const parts:string[] = this.name.split(' ');
        let pPars:string = '';
        let i:number = 0;
        for(let p of parts){
            if(i > 1){
                pPars += ' ' + p;
            }
            i++;
        }
        pPars = pPars.replace(' - ', ', ');
        return fChar + '. ' + (parts.length > 1 ? parts[1] : '');
    };
    public get namePosition():string{
        return this.name + ' #' + this.jersey + ' ' + this.positionAbbr;
    };

    public image: string = '';
    public thumb: string = '';
    public team: TeamScoreModel = new TeamScoreModel();
    public summerTeam: TeamScoreModel = new TeamScoreModel();
    public jersey: number = 0;// number
    public roster: number = 0;//roster
    public birthday: Date = new Date();//birthDate
    public birthcity = '';
    public birthStateProvince = '';
    public age: number = 0;
    public status: boolean = true;
    public position = '';
    public positionAbbr = '';
    public city = '';
    public country = '';
    public province = '';
    public throws  = '';
    public get throwsAbbr():string {
        const t = this.throws.toLowerCase();
        return t === 'right' ? 'D' : ( t === 'left' ? 'Z' : 'A');
    }
    public get throwsFull():string {
        const t = this.throws.toLowerCase();
        return t === 'right' ? 'Derecho' : ( t === 'left' ? 'Zurdo' : 'Ambidiestro');
    }
    public hits = '';
    public get hitsAbbr():string {
        const t = this.hits.toLowerCase();
        return t === 'right' ? 'D' : ( t === 'left' ? 'Z' : 'A');
    }
    public get hitsFull():string {
        const t = this.hits.toLowerCase();
        return t === 'right' ? 'Derecho' : ( t === 'left' ? 'Zurdo' : 'Ambidiestro');
    }
    public isForeign = false;
    public active = true;

    public height = '';
    public weight = '';
    public email = '';

    public fieldingStats: FieldingStatisticsModel = new FieldingStatisticsModel();
    public pitchingStats: PitchingStatisticsModel = new PitchingStatisticsModel();
    public battingStats: BattingStatisticsModel = new BattingStatisticsModel();
    public stats:PlayerStats = new PlayerStats();

    public byYearBattingStats: BattingStatisticsModel[] = [];
    public byYearPitchingStats: PitchingStatisticsModel[] = [];
    public byYearFieldingStats: FieldingStatisticsModel[] = [];

    public generalBattingStats: BattingStatisticsModel[] = [];
    public generalPitchingStats: PitchingStatisticsModel[] = [];
    public generalFieldingStats: FieldingStatisticsModel[] = [];
    
    public gameLogsBatting: BattingStatisticsModel[] = [];
    public gameLogsPitching: PitchingStatisticsModel[] = [];

    constructor(obj?: any) {
        if (obj) {

        }
    }

    public getLeaderStat(mode: string, column: string): string{
        const stats:any = mode == 'pitching' ? this.pitchingStats : ( mode == 'batting' ? this.battingStats : this.fieldingStats)
        return typeof stats[column] !== 'undefined' ? stats[column] : '';
    }

    public getStat(column: string, data: any): string{
        let col = column.toLowerCase();
        const excep = [
            { column:'año', value:'year'}, 
            { column:'j', value:'g'}, 
            { column:'2b', value:'h2b'}, 
            { column:'3b', value:'h3b'}
        ];
        for(let ex of excep){
            if(ex.column === col){
                col = ex.value;
            }
        }
        return typeof data[col] !== 'undefined' ? data[col] : '';
    }
}